import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";

import {
  CategoryDetailsResponseType,
  loginGameResType,
  loginGameType,
  SubGamePayLoad,
  SubGameResponse,
} from "./type";

export const GameApi = {
  loginGame: (typename: string, payload: loginGameType) =>
    axiosRequest.post<loginGameResType>(
      "",
      payloadHelper("LoginGame", typename, payload),
      {
        cancelToken: payload.source?.token,
      }
    ),
  getSubGame: (payload: SubGamePayLoad) =>
    axiosRequest.post<SubGameResponse>(
      "",
      payloadHelper("GetSubGameList", "", payload)
    ),

  getGameList: (game_type: string) =>
    axiosRequest.post<CategoryDetailsResponseType>(
      "",
      payloadHelper("GetGameList", game_type, { game_type })
    ),
  checkGamePromoOnOff: (username: string) =>
    axiosRequest.post<ApiResponse>(
      "",
      payloadHelper("checkPromotionOnOff", username, { username: username })
    ),
};
